/* eslint-disable react/prop-types */
import React from "react";

const tabStyles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    width: "100%",
    fontSize: "16px",
  },
  label: {
    fontWeight: 700,
    marginRight: 16,
    color: "#444",
    fontSize: "inherit",
  },
  // switch: {
  //   display: "flex",
  //   border: "1px solid #E5E7EB",
  //   borderRadius: "5px",
  //   overflow: "hidden",
  //   width: 140,
  //   height: 32,
  //   fontSize: "inherit",
  //   padding: 4,
  // },
  tab: {
    flex: 1,
    border: "solid 0.1px #E5E7EB",
    borderRadius: "3px",
    outline: "none",
    background: "#fff",
    color: "#444",
    fontWeight: 500,
    cursor: "pointer",
    transition: "background 0.2s, color 0.2s",
    fontSize: "inherit",
    padding: "10px 25px 10px 25px",
  },
  tabActive: {
    border: "none",
    background: "#EF6A5E",
    color: "#fff",
  },
};

const PromotionsTabsSwitch = ({
  label = "",
  tabs = ["Graph", "Totals"],
  value = 0,
  onChange,
}) => (
  <div style={tabStyles.container}>
    <span style={tabStyles.label}>{label}</span>
    <div style={tabStyles.switch}>
      {tabs.map((tab, idx) => (
        <button
          key={tab}
          type="button"
          style={{
            ...tabStyles.tab,
            ...(value === idx ? tabStyles.tabActive : {}),
          }}
          onClick={() => onChange && onChange(idx)}
        >
          {tab}
        </button>
      ))}
    </div>
  </div>
);

export default PromotionsTabsSwitch;
